export default {
  // One-to-One transfer
  'transfers.approve': 'Approve',
  'transfers.cancel': 'Cancel',
  'transfers.initiatedDate': 'Initiated Date/Time',
  'transfers.legend.transferDetails': 'Transfer Details',
  'transfers.reject': 'Reject',
  'transfers.single.recurring': 'Add Recurring Instruction',
  'transfers.transactionDate': 'Transaction Date',
  'transfers.transfersLabel': 'Transfers',
  'transfers.view.error': 'Sorry, there is some technical error while displaying the data.',
  'transfers.workflow.view': 'One-to-One Transfer'
};
